/// <reference lib="dom" />
/// <reference lib="es2020" />

/* eslint-disable react-hooks/rules-of-hooks */

import { ApplicationController } from '@application-controller';
import { useLoading } from '@mixin/use-loading';

/** @extends {ApplicationController} */
export class Controller extends ApplicationController {
  static targets = ['loadingIcon', 'textContent'];

  connect() {
    console.log('connected');
    useLoading(this);
    // TODO: probably not on window
    // TODO: handle for turbo nav
    window.addEventListener('pagehide', () => {
      this.stopLoading();
    });
  }
}
